'use strict';

/**
 * Listing of the unfished exports
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollectionView = require('base/Colido.CollectionView');
var ExportUnfinishedListItem = require('./export-unfinished-list-item');

var ExportUnfinishedList = ColidoCollectionView.extend({
    childView: ExportUnfinishedListItem,

    className: 'export-progress-list',

    tagName: 'ul',

    sortDefault: 'id.desc',
});

module.exports = ExportUnfinishedList;